// TODO: Refactor this before removing the JobCatalog::Repositories::TreeLevels

import { useState } from 'react'

import {
  Box,
  Button,
  CollapsableCard,
  Icon,
  Item,
  Text,
  Spinner,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { useQuery } from 'modules/core/hooks/useQuery'

import { MappingTable } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/CodeFillers/MappingTable'
import { upsertJobPositionMappings } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/CodeFillers/helpers'
import { A3InnuvaMapping } from 'modules/payroll_integrations_a3innuva/lib/types'
import { RolesAndLevelsEntitySelectorDocument } from 'generated/resources/graphql'

interface LegalEntity {
  id: number
  legalName: string
}

interface JobCatalogTreeDataSectionProps {
  legalEntities: LegalEntity[]
  isNewJobCatalogEnabled: boolean
  jobPositions?: {
    mappings?: A3InnuvaMapping[]
  }
  options: (legalEntityId: number) => Item[]
  updateMappings: (newMappings: A3InnuvaMapping[]) => void
  loading: boolean
}

export const JobCatalogTreeDataSection = ({
  legalEntities,
  isNewJobCatalogEnabled,
  jobPositions,
  options,
  updateMappings,
  loading,
}: JobCatalogTreeDataSectionProps) => {
  const { data, loading: jobCatalogTreeLevelsLoading } = useQuery(
    RolesAndLevelsEntitySelectorDocument,
    {
      variables: {
        legacyJobCatalog: !isNewJobCatalogEnabled,
      },
    }
  )

  const jobCatalogTreeLevels = data?.jobCatalog?.treeLevelsConnection?.nodes || []

  const defaultCardsState = () => {
    const defaultStates: Record<string, boolean> = {}

    legalEntities.forEach((legalEntity) => {
      defaultStates[legalEntity.id] = true
    })

    return defaultStates
  }

  const [openStates, setOpenStates] = useState<Record<string, boolean>>(defaultCardsState())

  const toggleCard = (id: string) => {
    setOpenStates((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const setFormValues = (selectedItem: Item, level: { id: number }, legalEntityId: number) => {
    const newMappings = upsertJobPositionMappings(
      jobPositions?.mappings || [],
      selectedItem,
      level.id.toString(),
      legalEntityId.toString()
    )
    updateMappings(newMappings)
  }

  const findSelection = (levelId: string, legalEntityId: number) => {
    const currentMapping = (jobPositions?.mappings || []).find((mapping) => {
      return (
        mapping.factorial_id.toString() === levelId.toString() &&
        mapping?.meta?.legal_entity_id === legalEntityId.toString()
      )
    })
    if (!currentMapping) return ''

    const selectedOption = options(legalEntityId).find(
      (option) => option.value === currentMapping.a3innuva_id
    )
    return selectedOption?.label || ''
  }

  if (loading || jobCatalogTreeLevelsLoading) return <Spinner />

  if (jobCatalogTreeLevels.length === 0) return null

  return (
    <>
      {legalEntities.map((legalEntity) => {
        return (
          <Box gap="s32" key={legalEntity.id} paddingBottom="s40">
            <Box background="grey200" borderRadius={{ all: 'abs008' }}>
              <CollapsableCard
                open={openStates[legalEntity.id] ?? false}
                contentBackground="grey000White"
                contentPadding="s0"
                Card={
                  <Box flexDirection="row" justifyContent="spaceBetween">
                    <Box flexDirection="row" gap="s8" alignItems="center">
                      <Icon.Large icon="building" />
                      <Text.Header3>{legalEntity.legalName}</Text.Header3>
                    </Box>
                    <Button
                      iconName={openStates[legalEntity.id] ? 'chevron-up' : 'chevron-down'}
                      onClick={() => toggleCard(legalEntity.id.toString())}
                      type="secondary"
                    />
                  </Box>
                }
                Content={
                  <MappingTable
                    title={i18n.t(
                      'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.mapping_table.a3innuva_fields'
                    )}
                    items={jobCatalogTreeLevels}
                    options={options(legalEntity.id)}
                    getItemId={(item) => item.id.toString()}
                    getItemLabel={(item) => `${item.ancestor?.name} - ${item.name}`}
                    onSelect={(selectedItem, item) =>
                      setFormValues(selectedItem, item, legalEntity.id)
                    }
                    findSelection={(item) => {
                      return findSelection(item, legalEntity.id)
                    }}
                    selectPlaceholder={i18n.t(
                      'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.levels.default_value_placeholder'
                    )}
                    loading={loading || jobCatalogTreeLevelsLoading}
                    customBorder={{
                      left: { color: 'grey000White', width: 's1', style: 'solid' },
                      right: { color: 'grey000White', width: 's1', style: 'solid' },
                      bottom: { color: 'grey000White', width: 's1', style: 'solid' },
                    }}
                  />
                }
              />
            </Box>
          </Box>
        )
      })}
    </>
  )
}
